// startup
// Load entry module and return exports
// This entry module used 'module' so it can't be inlined
__webpack_require__("./node_modules/slick-carousel/slick/slick.js");
var __webpack_exports__ = __webpack_require__("./resources/js/scripts.js");
